<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="会员提现管理"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="会员姓名">
            <el-input v-model="params.PersonName" placeholder="请输入会员姓名" clearable />
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="params.CheckType" placeholder="请选择审核状态" clearable>
             
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="审核通过" :value="1"></el-option>
              <el-option label="审核不通过" :value="2"></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item label="申请时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.ApplyStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.ApplyEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>
          

           <el-form-item label="提现时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.CashStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.CashEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>
        </template>
        <template slot="table">
          <el-table-column prop="PersonName" label="会员姓名" align="center" width="60" />
          <el-table-column prop="ApplyTime" label="申请时间" />
          <el-table-column prop="CashMoney" label="提现金额" />
          <el-table-column prop="CheckType" align="center" label="审核状态" width="80">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info" v-if="row.CheckType==0">待审核</el-tag>
            <el-tag size="small" type="primary" v-else-if="row.CheckType==1">审核通过</el-tag>
            <el-tag size="small" type="success" v-else-if="row.CheckType==2">审核不通过</el-tag>
         
          </template>
        </el-table-column>
         <el-table-column prop="TransferTime" label="转账时间" />
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         PersonName: "",
         CheckType: "",
         ApplyStarttime: null,
         ApplyEndtime: null,
         CashStarttime: null,
         CashEndtime: null,
        },
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{PersonName:"李东海",ApplyTime:"2024-03-13 10:01:12",CashMoney:80,CheckType:0,TransferTime:""},{PersonName:"陈钦",ApplyTime:"2024-03-11 17:51:17",CashMoney:20,CheckType:1,TransferTime:"2024-03-11 17:58:45"}]});
      })
    },
     
    },
  };
  </script>